import { useEffect, useState } from 'react';
import { EsclationReason, Ticket } from '../../../types/services.type';
import TrackStatus from '../../../services/getStatus.service';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../../constants';
import { toast } from 'react-toastify';
import { Button, Radio, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

export default function EsclationForm({
  show,
  setShow,
  ticket,
  onSuccess,
}: {
  show: boolean;
  setShow: any;
  ticket: Ticket;
  onSuccess: (msg: string) => void;
}) {
  const [reasons, setReasons] = useState<EsclationReason[]>([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [loading, setLoading] = useState(true);
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (!token) return;
    TrackStatus.getEsclationReasonsAsync(token)
      .then((data: EsclationReason[]) => {
        setReasons(data);
        setLoading(false);
      })
      .catch((error: any) => {
        console.log({ error });
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleEsclationRequest = async () => {
    if (selectedReason === '') {
      return toast.warn('Kindly select the reason to escalate.');
    }

    try {
      if (!token) return;

      let { status } = await TrackStatus.requestEscalationAsync(
        ticket.ticketNo,
        selectedReason,
        token,
      );
      if (status) {
        toast.success('Request Escalated');
        onSuccess('Your request has been escalated.');
      } else {
        toast.error('Something went wrong. Try again later.');
      }
      setLoading(false);
    } catch (error) {
      toast.error('Something went wrong');
      console.log(error);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setReasons([]);
    setShow(false);
    setSelectedReason('');
  };

  return (
    <div className="flex flex-col p-3">
      <Typography>
        {loading ? 'Please wait...' : 'Please select the reason to escalate:'}
      </Typography>
      {!loading &&
        reasons.map((r) => {
          return (
            <div
              onClick={() => setSelectedReason(r.escalationCode)}
              className="flex items-center cursor-pointer"
            >
              <Radio
                checked={selectedReason === r.escalationCode}
                name="reasons"
                inputProps={{ 'aria-label': 'A' }}
              />
              <Typography
                style={{
                  color: r.escalationCode === selectedReason ? PRIMARY_COLOR : SECONDARY_COLOR,
                }}
              >
                {r.escalationName}
              </Typography>
            </div>
          );
        })}
      <div className="flex items-center gap-3 mt-4">
        <Button variant="contained" disabled={loading} onClick={handleEsclationRequest}>
          Confirm
        </Button>
        <Button color="secondary" variant="outlined" disabled={loading} onClick={handleCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
